// Offer Type Enum
export const OfferType = {
	LONG: 'long', // 장기 계약
	SHORT: 'short', // 단기 계약
	PERIOD: 'period', // 기간 계약 (상반기/하반기)
}

// Term Type Enum (기간 타입 - period일 때만 사용)
export const TermType = {
	FIRST_HALF: 'first_half', // 상반기
	SECOND_HALF: 'second_half', // 하반기
	FULL_YEAR: 'full_year', // 상반기 + 하반기
}

// Initial State
export const storeInitState = {
	contractInput: {
		userId: '',
		targetUserId: '',
		contractGroupId: '',
		contractType: '',
		isTaxIncluded: true,
		isIncentiveTaxIncluded: true,
		weeklySalary: 0,
		weeklySalaryF: 0,
		percentage: 0,
		expenseReimbursementJeju: 0,
		wearSponsoredHat: true,
		contractStatus: 'PRE',
		etc: 'string',
		tourId: '',
	},
	offerInput: {
		// 서버 DTO와 1:1 매칭되는 구조
		targetUserId: '', // 제안 받는 캐디 ID
		message: '', // 제안 메시지
		offerType: '', // 'short', 'long', 'period'
		termType: '', // 'first_half', 'second_half', 'full_year' (period일 때만)
		tourIds: [], // 선택된 투어 ID 배열
		contract: {
			domesticContract: null, // 국내 계약 정보
			overseasContract: null, // 해외 계약 정보
			termContract: null, // 기간 계약 정보
		},
		selectedCaddie: null, // 선택된 캐디 전체 정보 (UI 표시용)
		selectedPro: null, // 선택된 프로 전체 정보 (캐디가 프로에게 제안 시)
	},
	signupInput: {
		// 투어프로 회원가입 데이터
		email: '',
		password: '',
		lastname: '',
		firstname: '',
		proCareer: '',
		mainSponsor: '',
		agency: '',
		businessLicense: '',
		// 서비스 동의 관련
		protection: false,
		useTerms: false,
		message: false,
		cash: false,
		fullTerms: false,
		// 인증 관련
		verificationData: {
			name: '',
			phoneNumber: '',
			association: '',
			memberNumber: '',
		},
	},
	onboardingInput: {
		// 온보딩 과정 데이터
		selectedTourIds: [], // 선택된 대회 ID 목록
		profileImage: '/images/Onboard-default-image.png', // 프로필 이미지
		preferredContract: {
			// 선호 계약 정보
			region: '', // 'BOTH', 'DOMESTIC', 'OVERSEAS'
			domesticContract: null,
			overseasContract: null,
		},
	},
	caddieInfoInput: {
		// 캐디 정보 수정 데이터
		careerLevel: '',
		caddieTeam: '',
		selfIntroduction: '',
		careers: [], // 경력 데이터
		languages: [], // 언어 데이터
	},
}

// Actions
export const initStore = (state, payload) => {
	return { ...storeInitState }
}

export const updateStore = (state, payload) => {
	return { ...state, ...payload }
}
